import {z} from 'zod';
import {zNumberToString} from '@brunata-angular/util';

export const webbillCostSpecificationsSchema = z.object({
    wbCostSpecificationId: zNumberToString,
    energyAmount: z.number().nullable(),
    consumptionAmount: z.number().nullable(),
    lineAmount: z.number().nullable(),
    consumptionCost: z.boolean(),
    energyUnit: z.string().nullable(),
    consumptionUnit: z.string().nullable(),
    vat: z.string().nullable(),
    lineNo: z.number().nullable(),
    lineText: z.string().nullable(),
    calculatedByBrunata: z.boolean(),
});

export type WebbillCostSpecifications = z.infer<typeof webbillCostSpecificationsSchema>;

export const oldWebbillCostSpecificationsSchema = z.object({
    vatIncl: z.enum(['J', 'N', 'E'] as const),
    amount: z.number().nullable(),
    description: z.string().nullable(),
    specification: z.string().nullable(),
});
